import React from 'react'
import { ArrowUpRight, ArrowDownRight, HelpCircle } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip'

interface MetricCardProps {
  title: string
  value: string | number
  change?: string
  icon: React.ComponentType<{ size?: string | number; className?: string }>
  trend?: 'up' | 'down' | 'neutral'
  tooltip?: string
}

export function MetricCard({
  title,
  value,
  change,
  icon: Icon,
  trend = 'neutral',
  tooltip
}: MetricCardProps) {
  const trendColors = {
    up: 'text-success',
    down: 'text-error',
    neutral: 'text-brand-gray'
  }

  const TrendIcon = trend === 'up' ? ArrowUpRight : ArrowDownRight

  return (
    <div className="metric-card group">
      <div className="flex items-center justify-between mb-4">
        <div className="p-2 rounded-monumenta bg-brand-primary/10 group-hover:bg-brand-primary/20 transition-colors duration-200">
          <Icon className="text-brand-primary group-hover:scale-110 transition-transform duration-200" size={24} />
        </div>
        {change && (
          <div className={`flex items-center text-sm font-display font-medium ${trendColors[trend]}`}>
            {trend !== 'neutral' && <TrendIcon size={16} className="mr-1" />}
            {change}
          </div>
        )}
      </div>
      <div className="metric-value">{value}</div>
      <div className="metric-label flex items-center gap-1">
        {title}
        {tooltip && (
          <TooltipProvider delayDuration={200}>
            <Tooltip>
              <TooltipTrigger asChild>
                <button className="inline-flex text-brand-gray hover:text-brand-primary transition-colors">
                  <HelpCircle size={14} />
                </button>
              </TooltipTrigger>
              <TooltipContent
                side="top"
                className="max-w-xs bg-brand-dark-light border border-gray-700 text-white z-[9999]"
                sideOffset={8}
              >
                <p>{tooltip}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>
    </div>
  )
}